var map = {
	"./icon0-active.png": 56,
	"./icon0.png": 57,
	"./icon1-active.png": 58,
	"./icon1.png": 59,
	"./icon2-active.png": 60,
	"./icon2.png": 61,
	"./icon3-active.png": 62,
	"./icon3.png": 63,
	"./icon4-active.png": 64,
	"./icon4.png": 65,
	"./icon5-active.png": 66,
	"./icon5.png": 67,
	"./icon6-active.png": 68,
	"./icon6.png": 69,
	"./icon7-active.png": 70,
	"./icon7.png": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;